import { AxiosInstance } from 'axios'

import { CurrentUserDTO } from '@modules/users/types/Users/users'

export class UsersService {
  private instance: AxiosInstance

  constructor(instance: AxiosInstance) {
    this.instance = instance
  }

  async getCurrentUser(): Promise<CurrentUserDTO> {
    const response = await this.instance.get(`/users/me`)

    return response.data
  }
}

export const usersService = (instance: AxiosInstance) => new UsersService(instance)
